import { Button } from "../../../../../../components/ui/Button";
import { BeautyProfilerAllure } from "../../../../types/BeautyProfilerAllure";

type BeautyProfilerAllureSectionProps = {
  topAllure: BeautyProfilerAllure | null;
  onDiscoverClick: () => void;
};

export const BeautyProfilerAllureSection = ({
  topAllure,
  onDiscoverClick,
}: BeautyProfilerAllureSectionProps) => {
  return (
    <div className="flex flex-col items-center gap-2 p-4 z-1">
      <div>
        <p className="text-[#050505] text-center font-garamond-italic text-[20px] italic font-normal">
          Step into
        </p>
        <h1 className="text-[#050505] text-center font-bebas-kai text-[37px] font-normal leading-normal">
          The <span className="text-primary">{topAllure?.label}</span> allure
          à la louboutin
        </h1>
      </div>
      <p className="text-[#050505] text-justify font-minion text-[20px] font-normal leading-[150%]">
        {topAllure?.description}
      </p>
      <Button variant="discover" onClick={onDiscoverClick}>
        <p className="px-4">Discover</p>
      </Button>
    </div>
  );
}; 